import {
	ElementRef,
	Injectable,
	Renderer2,
	RendererStyleFlags2,
} from '@angular/core';

@Injectable()
export class ConsumerConfigViewProvider {
	private readonly GAP_PX = 85;
	private readonly PANEL_HEADER = 48;
	private readonly ALERT = 43;

	public adjustHeights(elemRef: ElementRef, renderer: Renderer2): void {
		const modalContent =
			elemRef.nativeElement.querySelector('.app-modal-content');

		const projectCard = elemRef.nativeElement.querySelector(
			'.project-details-card'
		);

		const profileList = document.querySelector(
			'.app-consumer-config-modal .app-subscription-profile-list'
		) as HTMLElement | null;

		const profileListHeight =
			modalContent.offsetHeight -
			projectCard.offsetHeight -
			this.GAP_PX -
			this.PANEL_HEADER -
			this.ALERT;

		renderer.setStyle(
			profileList,
			'--max-height-profiles',
			`${profileListHeight}px`,
			RendererStyleFlags2.DashCase
		);
	}
}
